/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesAddOnProduct } from './WebApiModelsEnumerationTypesAddOnProduct';
import {
    WebApiModelsEnumerationTypesAddOnProductFromJSON,
    WebApiModelsEnumerationTypesAddOnProductFromJSONTyped,
    WebApiModelsEnumerationTypesAddOnProductToJSON,
} from './WebApiModelsEnumerationTypesAddOnProduct';
import type { WebApiModelsEnumerationTypesCompanyOrderStatus } from './WebApiModelsEnumerationTypesCompanyOrderStatus';
import {
    WebApiModelsEnumerationTypesCompanyOrderStatusFromJSON,
    WebApiModelsEnumerationTypesCompanyOrderStatusFromJSONTyped,
    WebApiModelsEnumerationTypesCompanyOrderStatusToJSON,
} from './WebApiModelsEnumerationTypesCompanyOrderStatus';

/**
 * 
 * @export
 * @interface WebApiPaymentRepositoryStripeConfirmResponse
 */
export interface WebApiPaymentRepositoryStripeConfirmResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WebApiPaymentRepositoryStripeConfirmResponse
     */
    hasSuccessfullyPayed?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesCompanyOrderStatus}
     * @memberof WebApiPaymentRepositoryStripeConfirmResponse
     */
    paymentStatus?: WebApiModelsEnumerationTypesCompanyOrderStatus;
    /**
     * 
     * @type {Date}
     * @memberof WebApiPaymentRepositoryStripeConfirmResponse
     */
    nextSubscriptionRenewalDate?: Date | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesAddOnProduct}
     * @memberof WebApiPaymentRepositoryStripeConfirmResponse
     */
    addOnProduct?: WebApiModelsEnumerationTypesAddOnProduct;
}

/**
 * Check if a given object implements the WebApiPaymentRepositoryStripeConfirmResponse interface.
 */
export function instanceOfWebApiPaymentRepositoryStripeConfirmResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPaymentRepositoryStripeConfirmResponseFromJSON(json: any): WebApiPaymentRepositoryStripeConfirmResponse {
    return WebApiPaymentRepositoryStripeConfirmResponseFromJSONTyped(json, false);
}

export function WebApiPaymentRepositoryStripeConfirmResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPaymentRepositoryStripeConfirmResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasSuccessfullyPayed': !exists(json, 'hasSuccessfullyPayed') ? undefined : json['hasSuccessfullyPayed'],
        'paymentStatus': !exists(json, 'paymentStatus') ? undefined : WebApiModelsEnumerationTypesCompanyOrderStatusFromJSON(json['paymentStatus']),
        'nextSubscriptionRenewalDate': !exists(json, 'nextSubscriptionRenewalDate') ? undefined : (json['nextSubscriptionRenewalDate'] === null ? null : new Date(json['nextSubscriptionRenewalDate'])),
        'addOnProduct': !exists(json, 'addOnProduct') ? undefined : WebApiModelsEnumerationTypesAddOnProductFromJSON(json['addOnProduct']),
    };
}

export function WebApiPaymentRepositoryStripeConfirmResponseToJSON(value?: WebApiPaymentRepositoryStripeConfirmResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasSuccessfullyPayed': value.hasSuccessfullyPayed,
        'paymentStatus': WebApiModelsEnumerationTypesCompanyOrderStatusToJSON(value.paymentStatus),
        'nextSubscriptionRenewalDate': value.nextSubscriptionRenewalDate === undefined ? undefined : (value.nextSubscriptionRenewalDate === null ? null : value.nextSubscriptionRenewalDate.toISOString()),
        'addOnProduct': WebApiModelsEnumerationTypesAddOnProductToJSON(value.addOnProduct),
    };
}

